import { render } from "./CommunicationDataScreen.vue?vue&type=template&id=98121942&scoped=true&lang=html"
import script from "./CommunicationDataScreen.vue?vue&type=script&lang=js"
export * from "./CommunicationDataScreen.vue?vue&type=script&lang=js"

import "./CommunicationDataScreen.vue?vue&type=style&index=0&id=98121942&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/multiple_choice_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98121942"]])

export default __exports__